import "./datadogRum";
import React, { useEffect } from "react";
import ReactDOM from "react-dom";
import { createRoot } from "react-dom/client";
import "./index.css";
import App from "./App"; //entry point for the actual app
import "font-awesome/css/font-awesome.min.css";
import { BrowserRouter } from "react-router-dom";
import { Provider as RawProvider } from "react-redux";
import store from "./Redux/store";
import { HelmetProvider } from "react-helmet-async";
import { SidebarProvider } from "./contexts/SidebarContext";
import { msConfig } from "./Services/authService";
import { MsalProvider } from "@azure/msal-react";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import AuthAD from "./Auth";
import { env } from "./env";
import * as devtool from "./devtools";
import OEMSignOffPage from "./pages/master/UsecaseDashboard/SATSignOff/OEMDocUploadPage";
import { registerLicense } from "@syncfusion/ej2-base";
import DatadogUserIdentify from "./DatadogUserIdentify";

registerLicense(env.eam_syncfusion_license);

const DEBUG = env.environment === "DEV";

/**
 * Debug configuration
 */
if (!DEBUG) {
  devtool.disableConsoleLogs();
  devtool.disableContextMenu();
  devtool.disableHotKeys();
  devtool.legalDevtoolWarning();
  // devtool.disable40XErrorConsoleLogs();
}
const Provider = RawProvider as unknown as React.ComponentType<any>;
const rootElement: any = document.getElementById("root")
const root = createRoot(rootElement)
const urlSegments = window.location.hash.split("/");
const url = urlSegments.slice(1, urlSegments.length).join("/");

const qc = new QueryClient();

root.render(
  <HelmetProvider>
    <Provider store={store}>
      <SidebarProvider>
        <BrowserRouter>
          {url.includes("sat/upload-docs/") ? (
            <OEMSignOffPage />
          ) : (
            <MsalProvider instance={msConfig}>
              <AuthAD>
                <QueryClientProvider client={qc}>
                  <DatadogUserIdentify />
                  <App />
                </QueryClientProvider>
              </AuthAD>
            </MsalProvider>
          )}
        </BrowserRouter>
      </SidebarProvider>
    </Provider>
  </HelmetProvider>
);
